import { TeamArmy } from './TeamArmy';
import { Nullable } from '../../Nullable';
import { v4 as uuidv4 } from 'uuid';

export interface Draw {
  id: string;
  teamId: string;
  myTeamArmyId: string;
  myTeamArmy: TeamArmy;
  myTeamArmyConfirmed: boolean;
  propositionTeamArmyOneId: Nullable<string>;
  propositionTeamArmyOne: Nullable<TeamArmy>;
  propositionTeamArmyTwoId: Nullable<string>;
  propositionTeamArmyTwo: Nullable<TeamArmy>;
  propositionTeamArmyConfirmed: boolean;
  selectedTeamArmyId: Nullable<string>;
  selectedTeamArmy: Nullable<TeamArmy>;
  selectedTeamArmyConfirmed: boolean;
}

export const newDraw = (teamId: string, teamArmy: TeamArmy): Draw => {
  return {
    id: uuidv4(),
    teamId: teamId,
    myTeamArmyId: teamArmy.id,
    myTeamArmy: teamArmy,
    myTeamArmyConfirmed: false,
    propositionTeamArmyConfirmed: false,
    propositionTeamArmyOneId: null,
    propositionTeamArmyOne: null,
    propositionTeamArmyTwoId: null,
    propositionTeamArmyTwo: null,
    selectedTeamArmyId: null,
    selectedTeamArmy: null,
    selectedTeamArmyConfirmed: false,
  } satisfies Draw as Draw;
};
